/* ax motion (v3 overhaul, 16-10-2026): the scroll choreography of the ax-* sections. GSAP 3.15 + ScrollTrigger (+ Lenis when the
   skin asks for inertia scroll), all vendored. Rules:
   - nothing is hidden without this file: initial states are set here, only when GSAP runs and the visitor allows motion;
   - initial states use opacity / transform / custom properties only (never visibility or display), so innerText, copy gates
     and screen readers always see every word;
   - word reveal wraps each word in inline-block spans and keeps the whitespace text nodes, so the text is unchanged;
   - one choreography per component, named by its data attribute in the section markup. */
(function () {
  if (window.__ax) return; window.__ax = 1;
  var root = document.documentElement;
  var skin = document.querySelector('[data-ax-skin]');
  if (!skin) return;
  var fam = skin.getAttribute('data-ax-skin');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  function $$(sel, r) { return Array.prototype.slice.call((r || document).querySelectorAll(sel)); }

  function start() {
    var g = window.gsap, ST = window.ScrollTrigger;
    if (!skin.hasAttribute('data-ax-motion') || reduce || !g || !ST) return;
    g.registerPlugin(ST);
    root.classList.add('ax-mo');

    // inertia scroll (desktop wheel only; touch keeps native scrolling)
    if (skin.hasAttribute('data-ax-smooth') && window.Lenis && fine) {
      try {
        var lenis = new window.Lenis({ lerp: 0.12, smoothWheel: true, anchors: { offset: -90 } });
        lenis.on('scroll', ST.update);
        g.ticker.add(function (t) { lenis.raf(t * 1000); });
        g.ticker.lagSmoothing(0);
        window.__axLenis = lenis;
      } catch (e) { /* native scroll */ }
    }

    // 1. headings: words rise out of a mask
    $$('.ax [data-ax-split]').forEach(function (h) {
      if (h.closest('.ax-main')) return;
      var walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT, null), nodes = [], n;
      while ((n = walker.nextNode())) nodes.push(n);
      nodes.forEach(function (t) {
        var parts = t.nodeValue.split(/(\s+)/), frag = document.createDocumentFragment();
        parts.forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
          var o = document.createElement('span'), i = document.createElement('span');
          o.className = 'ax-wd'; i.textContent = p; o.appendChild(i); frag.appendChild(o);
        });
        t.parentNode.replaceChild(frag, t);
      });
      var inner = $$('.ax-wd > span', h);
      g.set(inner, { yPercent: 108 });
      ST.create({ trigger: h, start: 'top 88%', once: true, onEnter: function () {
        g.to(inner, { yPercent: 0, duration: 0.95, ease: 'power3.out', stagger: 0.045 });
      } });
    });

    // 2. generic rise for content (the buy box stays still: it is the first thing on screen)
    var rise = $$('.ax-flow .ax-col > :not([data-ax-split]):not(.ax-fig):not(.ax-pairs):not(.ax-steps):not(.ax-ncards):not([data-ax-strike]):not([data-ax-esc]):not([data-ax-gauge]):not([data-ax-ladder]):not([data-ax-circles]):not([data-ax-shift]):not([data-ax-giant]),.ax-card, .ax-pair, .ax-step, .ax-ncard, .ax-acc__item, .ax-cmp, .ax-cmpsec__head > :not([data-ax-split]), .ax-cardsec__head > :not([data-ax-split]), .ax-accsec__intro, .ax-cardsec__foot')
      .filter(function (e) { return !e.closest('.ax-main') && !e.closest('.ax-sticky'); });
    // 17-10 art-director review ("nothing visibly moves"): a longer, slower rise (44px, 1s) so the entrance reads as motion
    g.set(rise, { opacity: 0, y: 44 });
    ST.batch(rise, { start: 'top 90%', once: true, onEnter: function (els) {
      g.to(els, { opacity: 1, y: 0, duration: 1, ease: 'power3.out', stagger: 0.1, overwrite: true });
    } });

    // 3. pictures: framed ones are uncovered top-down, open ones drift (parallax)
    $$('.ax-fig--frame img').forEach(function (im) {
      g.set(im, { clipPath: 'inset(0 0 100% 0)' });
      ST.create({ trigger: im, start: 'top 85%', once: true, onEnter: function () {
        g.to(im, { clipPath: 'inset(0 0 0% 0)', duration: 1.2, ease: 'power3.inOut' });
      } });
    });
    // open pictures are uncovered from the bottom as they enter (the drift below keeps running inside the uncovered frame)
    $$('.ax-fig:not(.ax-fig--frame), .ax-card__img, .ax-bleed__img').forEach(function (box) {
      if (box.closest('.ax-main')) return;
      g.set(box, { clipPath: 'inset(18% 0 0 0)' });
      ST.create({ trigger: box, start: 'top 88%', once: true, onEnter: function () {
        g.to(box, { clipPath: 'inset(0% 0 0 0)', duration: 1.2, ease: 'power3.out' });
      } });
    });
    $$('.ax-fig:not(.ax-fig--frame) img, .ax-card__img img, .ax-bleed__img img').forEach(function (im) {
      if (im.closest('.ax-main')) return;
      g.fromTo(im, { scale: 1.12, yPercent: -4 }, { scale: 1.12, yPercent: 4, ease: 'none',
        scrollTrigger: { trigger: im.parentNode, start: 'top bottom', end: 'bottom top', scrub: true } });
    });

    // 4. struck negations: the bar draws across each line in turn
    $$('[data-ax-strike]').forEach(function (box) {
      var lines = $$('li, p', box);
      g.set(lines, { '--ax-s': 0 });
      ST.create({ trigger: box, start: 'top 78%', once: true, onEnter: function () {
        g.to(lines, { '--ax-s': 1, duration: 0.55, ease: 'power2.inOut', stagger: 0.3, delay: 0.2 });
      } });
    });

    // 5. question shift: strike the old question, then the new one rises
    $$('[data-ax-shift]').forEach(function (box) {
      var old = box.querySelector('.ax-shift__old'), nw = box.querySelector('.ax-shift__new');
      if (!old || !nw) return;
      g.set(old, { '--ax-s': 0 });
      g.set(nw, { opacity: 0, y: 30 });
      ST.create({ trigger: box, start: 'top 75%', once: true, onEnter: function () {
        g.timeline().to(old, { '--ax-s': 1, duration: 0.7, ease: 'power2.inOut', delay: 0.3 })
          .to(nw, { opacity: 1, y: 0, duration: 0.9, ease: 'power3.out' }, '+=0.15');
      } });
    });

    // 6. the day gets heavier: lines arrive one after another
    $$('[data-ax-esc] li').length && $$('[data-ax-esc]').forEach(function (box) {
      var li = $$('li', box);
      g.set(li, { opacity: 0, x: -18 });
      ST.create({ trigger: box, start: 'top 80%', once: true, onEnter: function () {
        g.to(li, { opacity: 1, x: 0, duration: 0.6, ease: 'power2.out', stagger: 0.22 });
      } });
    });

    // 7. protocol stepper: the active step follows the scroll
    $$('[data-ax-stepper]').forEach(function (box) {
      var li = $$('li', box); if (!li.length) return;
      function on(k) { li.forEach(function (x, i) { x.classList.toggle('is-on', i === k); }); }
      on(0);
      ST.create({ trigger: box, start: 'top 80%', end: 'bottom 30%', onUpdate: function (s) {
        on(Math.min(li.length - 1, Math.floor(s.progress * li.length)));
      } });
    });

    // 8. sweet-spot gauge: the sides settle back, the middle lands
    $$('[data-ax-gauge]').forEach(function (box) {
      var sides = $$('.ax-gauge__side', box), mid = box.querySelector('.ax-gauge__mid'), mark = box.querySelector('.ax-gauge__mark');
      g.set(sides[0], { opacity: 0, x: -30 }); g.set(sides[1], { opacity: 0, x: 30 });
      g.set(mid, { scale: 0.94, opacity: 0 }); if (mark) g.set(mark, { y: -24, opacity: 0 });
      ST.create({ trigger: box, start: 'top 80%', once: true, onEnter: function () {
        var tl = g.timeline();
        tl.to(sides, { opacity: 1, x: 0, duration: 0.7, ease: 'power2.out' })
          .to(mid, { scale: 1, opacity: 1, duration: 0.7, ease: 'power3.out' }, '-=0.35');
        if (mark) tl.to(mark, { y: 0, opacity: 1, duration: 0.8, ease: 'bounce.out' }, '-=0.3');
      } });
    });

    // 9. dose ladder: the bars grow, low to high
    $$('[data-ax-ladder] li').length && $$('[data-ax-ladder]').forEach(function (box) {
      var li = $$('li', box), side = window.matchMedia('(max-width: 749px)').matches;  // phone: the steps grow sideways
      g.set(li, side ? { scaleX: 0, transformOrigin: 'left center' } : { scaleY: 0, transformOrigin: 'bottom center' });
      ST.create({ trigger: box, start: 'top 82%', once: true, onEnter: function () {
        g.to(li, side ? { scaleX: 1, duration: 0.9, ease: 'power3.out', stagger: 0.25 } : { scaleY: 1, duration: 0.9, ease: 'power3.out', stagger: 0.25 });
      } });
    });

    // 10. the giant line grows into place with the scroll
    $$('[data-ax-giant]').forEach(function (el) {
      g.fromTo(el, { scale: 0.84 }, { scale: 1, ease: 'none',
        scrollTrigger: { trigger: el, start: 'top 95%', end: 'top 45%', scrub: true } });
    });

    // 11. Brew. Sip. Repeat.: the cups fill one after another
    $$('[data-ax-circles]').forEach(function (box) {
      var li = $$('li', box);
      g.set(li, { scale: 0.55, opacity: 0 });
      ST.create({ trigger: box, start: 'top 82%', once: true, onEnter: function () {
        g.to(li, { scale: 1, opacity: 1, duration: 0.8, ease: 'back.out(1.6)', stagger: 0.32 });
      } });
    });

    // 12. bands: words and checks arrive in a row
    $$('[data-ax-strip]').forEach(function (ul) {
      if (ul.closest('.ax-strip--marquee')) return;
      var it = $$('li', ul);
      g.set(it, { opacity: 0, y: 24 });
      ST.create({ trigger: ul, start: 'top 92%', once: true, onEnter: function () {
        g.to(it, { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out', stagger: 0.09 });
      } });
    });

    // 13. drawn lines (pulse) and journey nodes
    $$('.ax-draw').forEach(function (p) {
      g.set(p, { strokeDasharray: 1, strokeDashoffset: 1 });
      ST.create({ trigger: p.closest('svg'), start: 'top 85%', once: true, onEnter: function () {
        g.to(p, { strokeDashoffset: 0, duration: 1.6, ease: 'power2.inOut' });
      } });
    });
    $$('.ax-card__node').forEach(function (n) {
      ST.create({ trigger: n.closest('.ax-card'), start: 'top 70%', once: true, onEnter: function () {
        g.fromTo(n, { scale: 0.2 }, { scale: 1, duration: 0.7, ease: 'back.out(3)' });
      } });
    });

    // 14. the steep strip under the Hibiscus gallery fills, water to ruby night
    $$('.ax-steep span').length && g.from($$('.ax-steep span'), { scaleX: 0, transformOrigin: 'left center', duration: 0.5, ease: 'power2.out', stagger: 0.12, delay: 0.4 });

    // 15. buttons lean toward the pointer (desktop)
    if (fine) $$('.ax-btn, .ax-main .ax-atc').forEach(function (b) {
      var xTo = g.quickTo(b, 'x', { duration: 0.4, ease: 'power3' }), yTo = g.quickTo(b, 'y', { duration: 0.4, ease: 'power3' });
      b.addEventListener('pointermove', function (e) { var r = b.getBoundingClientRect(); xTo((e.clientX - r.left - r.width / 2) * 0.12); yTo((e.clientY - r.top - r.height / 2) * 0.2); });
      b.addEventListener('pointerleave', function () { xTo(0); yTo(0); });
    });

    // 16. bundle choice: the picked option answers
    $$('.ax-main .ax-tier input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', function () { var t = r.closest('.ax-tier'); if (t) g.fromTo(t, { scale: 0.985 }, { scale: 1, duration: 0.45, ease: 'back.out(3)' }); });
    });

    window.addEventListener('load', function () { ST.refresh(); }, { once: true });

    // 17-10: a 3D block (cro-cine-seq, product.ax-*-3d) that falls back to its static layout after load is ~2 screens shorter than
    // the pinned layout these triggers were measured on: re-measure when its layout class flips. Pages without the block never flip it.
    if (window.MutationObserver) {
      var cine = root.classList.contains('cro-cine-on');
      new MutationObserver(function () {
        var on = root.classList.contains('cro-cine-on');
        if (on !== cine) { cine = on; ST.refresh(); }
      }).observe(root, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
